import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { keycloak } from "../..";
import { TICKET_API } from "../../constants/constants";
import { defaultHeaders } from "../../utils/params";

export const ticketServiceApi = createApi({
  reducerPath: "ticketServiceApi",
  baseQuery: async (args, api, extraOptions) => {
    const baseQuery = fetchBaseQuery({
      baseUrl: TICKET_API,
      // prepareHeaders: async (headers, { getState }) => {
      //   const token = (getState() as any)?.auth?.access_token;

      //   if (token) {
      //     headers.set("Authorization", `Bearer ${token}`);
      //   }

      //   headers.set("ngrok-skip-browser-warning", "true");
      //   headers.set("productid", "14");

      //   return headers;
      // },
      prepareHeaders: async (headers, { getState }) => {
        const token = (getState() as any)?.auth?.access_token;

        return defaultHeaders(headers, token);
      },
    });

    const result = await baseQuery(args, api, extraOptions);

    // if (
    //   result.error &&
    //   result.error?.status === 401 &&
    //   (result?.error?.data as any)?.message === "Unauthorized"
    // ) {
    //   localStorage.removeItem(AUTH_LOCALSTORAGE_NAME);
    //   window.location.reload();
    // }
    if (
      result.error &&
      result.error?.status === 401 &&
      (result?.error?.data as any)?.message === "Unauthorized"
    ) {
      try {
        await keycloak.logout();
        localStorage.clear();
      } catch (err) {
        console.error("Keycloak logout failed:", err);
      }
    }

    return result;
  },
  tagTypes: [
    // Templates
    "GetAllTemplates",

    // Tickets
    "GetAllTickets",
    "GetAllCategories",
    "GetTicketDetails",
    "GetRaiseTickets",
    "GetAllMyTickets",
    "GetAllMyTicketDetails",
    "GetApprovalHubTickets",
    "GetAllTicketLogs",
    "GetCCList",
    "GetTicketIDRelatedNotifications",
    "GetTicketForCC",
    "GetOneToOneChatList",
    "GetMailList",
    "GetSingleMailById",
    "GetReplyMailByParentMail",
    "GetGroupChat",
    "GetGroupChatDetails",
    "GetGroupMember",
    "GetGroupAttachments",
    "GetChatAttachments",
    "GetFilterGroupUser",
    "GetOneToOneConversation",
    "GetTags",
    "GetCommentHistory",
    "GetNotifications",
    "GetAllProducts",
    "GetAllFeatures",
    "GetAllReports"
  ],
  keepUnusedDataFor: 2,
  endpoints: () => ({}),
});
